module.exports = __webpack_public_path__ + "static/media/image5.926faf06.jpg";